// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GeoT","largestCol":"styles_largestCol__L2xGM","smallestCol":"styles_smallestCol__m3yQQ"};